<template>
  <el-dialog  title="收集题卡信息"
  width="1024px"
  @open="dialogOpen"
  :before-close="handleClose"
  :close-on-click-modal="false"
  :visible.sync="visible">
    <div class="main-container">
      <div class="left-container">
        <el-menu
          :default-active="menuIndex"
          class="select-menu"
          @select="menuSelect">
          <el-menu-item index="1">
            <i class="el-icon-picture-outline"></i>
            <span>纸质卡</span>
          </el-menu-item>
          <!-- <el-menu-item index="2">
            <i class="el-icon-printer"></i>
            <span slot="title">网阅卡</span>
          </el-menu-item> -->
          <el-menu-item index="3">
            <i class="el-icon-document"></i>
            <span slot="title">手阅卡</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="right-container">
        <div  class="oprate-wrap">
          <div v-if="menuIndex === '1'" class="none-card-info">
            <div v-if="existModel" class="paper-left">
              <div class="item-info-wrap">
                <div class="title">
                  <span class="key">当前</span>模版信息：
                </div>
                <div class="items">
                  <div class="omr-info">
                    <div style="padding-bottom:10px;">客观题：{{ cardInfo.omr.length }} 题</div>
                    <el-table max-height="390" :data="cardInfo.omr" class="kaow-table">
                      <el-table-column type="index" label="序号" />
                      <el-table-column prop="Item_Id" label="题号" />
                      <!-- <el-table-column label="类型">
                        <template slot-scope="scope">
                          {{ scope.row.option === '1' ? '选做题' : '必做题' }}
                        </template>
                      </el-table-column> -->
                    </el-table>
                  </div>
                  <div class="zg-info">
                    <div style="padding-bottom:10px;">主观题：{{ cardInfo.zg.length }} 题</div>
                    <el-table max-height="390" v-if="cardInfo.zg.length > 0"
                        :data="cardInfo.zg" class="kaow-table">
                      <el-table-column type="index" label="序号" />
                      <el-table-column prop="Item_Id" label="题号" />
                      <el-table-column label="类型">
                        <template slot-scope="scope">
                          {{ scope.row.option === '1' ? '选做题' : '必做题' }}
                        </template>
                      </el-table-column>
                    </el-table>
                    <div v-else class="no-zg">
                      <p class="text">无主观题信息</p>
                      <p class="text">可到右侧“主观题画块”中进行主观题设置</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="paper-left">
              <p class="exam-name">{{ examName + '-' + subjectName }}</p>
              <a href="javascript:void(0);" @click="getPaperCard" class="collect-button">
                <i class="iconfont icon-diannao"></i>
                <span class="text">开始收集</span>
              </a>
            </div>
            <div v-if="existModel" class="paper-right">
              <a href="javascript:void(0);" @click="getPaperCard" class="collect-button-small">
                <i class="iconfont icon-diannao"></i>
                <span style="color:white;">重新收集</span>
              </a>
              <a style="margin-top: 90px;" href="javascript:void(0);"  @click="drawZg"  class="collect-button-small" rel="noopener noreferer nofollow">
                <i class="iconfont icon-pen"></i>
                <span style="color:white;">主观题画块</span>
              </a>
            </div>
          </div>
          <div v-else-if="menuIndex === '2'" class="onlie-card">
            <div class="search-container">
                <div style="width:230px">
                  <el-date-picker class="date-picker" size="mini"
                    v-model="search_dateVals"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  />
                </div>
                <div class="search-item">
                   <el-select placeholder="纸张类型" clearable  width="80px" v-model="search_cardType" size="mini">
                    <el-option v-for="item in cardTypes"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type" />
                  </el-select>
                </div>
                <div class="search-item" style="width:120px;">
                   <el-select placeholder="准考证类型" clearable  v-model="search_codeType" size="mini">
                    <el-option v-for="item in codeTypes"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type" />
                  </el-select>
                </div>
                <div class="search-item" style="width:150px;">
                  <el-input type="text" size="mini" v-on:keyup.enter.native="searchCard(-1)" placeholder="题卡名称" v-model="search_cardName">
                  </el-input>
                </div>
                <div class="search-item" style="width:90px;margin-left:110px;">
                  <el-button size="mini" type="primary"  @click="searchCard(-1)" :loading="submitLoading">查 询</el-button>
                </div>
            </div>
            <div class="table_container">
              <el-table ref="onlineCardTable" :data="cardData" highlight-current-row class="card-table kaow-table" @current-change="selectRow">
                <el-table-column prop="operCode" label="选择" width="60">
                  <template slot-scope="scope">
                    <el-radio :label="scope.row.cardId" v-model="selectedCardId">{{scope.row.cardIdEmpty}}</el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="120"/>
                <el-table-column prop="cardType" label="纸张" width="72" />
                <!-- <el-table-column prop="title" label="题卡名称" width="130"/> -->
                <el-table-column
                  label="题卡名称"
                  width="150">
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                      <p>{{ scope.row.title }}</p>
                      <div slot="reference" class="name-wrapper">
                        {{scope.row.cardName}}
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  label="关联试卷"
                  width="120">
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                      <p>{{ scope.row.paperName }}</p>
                      <div slot="reference" class="name-wrapper">
                        {{scope.row.paperNameShort}}
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="zkzhType" label="准考证号" width="100" />
                <el-table-column prop="selectCnt" label="单选题" width="59" />
                <el-table-column prop="multiSelectCnt" label="多选题" width="59" />
                <el-table-column prop="judgeCnt" label="判断题" width="59"  />
                <el-table-column prop="itemCnt" label="主观题" width="59" />
              </el-table>
              <div class="pager">
                <el-pagination class="pager"
                layout="total, prev, pager, next, jumper"
                :page-size="pageSize"
                :total="total"
                :current-page.sync="currentPage"
                @current-change="handlePageChange" />
              </div>
            </div>
          </div>
           <div v-else-if="menuIndex === '3'" class="onlie-card">
            <div class="search-container">
                <div style="width:230px">
                  <el-date-picker class="date-picker" size="mini"
                    v-model="search_dateVals"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  />
                </div>
                <div class="search-item">
                   <el-select placeholder="纸张类型" clearable  width="80px" v-model="search_cardType" size="mini">
                    <el-option v-for="item in cardTypes"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type" />
                  </el-select>
                </div>
                <div class="search-item" style="width:120px;">
                  <el-select placeholder="准考证类型" clearable  v-model="search_codeType" size="mini">
                    <el-option v-for="item in codeTypes"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type" />
                  </el-select>
                </div>
                <div class="search-item" style="width:150px;">
                  <el-input type="text" size="mini" v-on:keyup.enter.native="searchCard(-1)" placeholder="题卡名称" v-model="search_cardName">
                  </el-input>
                </div>
                <div class="search-item" style="width:90px;margin-left:110px;">
                  <el-button size="mini" type="primary"  @click="searchCard(-1)" :loading="submitLoading">查 询</el-button>
                </div>
            </div>
            <div class="table_container">
              <el-table ref="scoreCardTable" :data="cardData" highlight-current-row class="card-table kaow-table" @current-change="selectRow">
                <el-table-column prop="operCode" label="选择" width="60">
                  <template slot-scope="scope">
                    <el-radio :label="scope.row.cardId" v-model="selectedCardId">{{scope.row.cardIdEmpty}}</el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="120"/>
                <el-table-column prop="cardType" label="纸张" width="72" />
                <!-- <el-table-column prop="title" label="题卡名称" width="130"/> -->
                <el-table-column
                  label="题卡名称"
                  width="150">
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                      <p>{{ scope.row.title }}</p>
                      <div slot="reference" class="name-wrapper">
                        {{scope.row.cardName}}
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  label="关联试卷"
                  width="120">
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                      <p>{{ scope.row.paperName }}</p>
                      <div slot="reference" class="name-wrapper">
                        {{scope.row.paperNameShort}}
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="zkzhType" label="准考证号" width="100" />
                <el-table-column prop="selectCnt" label="单选题" width="59" />
                <el-table-column prop="multiSelectCnt" label="多选题" width="59" />
                <el-table-column prop="judgeCnt" label="判断题" width="59"  />
                <el-table-column prop="itemCnt" label="主观题" width="59" />
              </el-table>
              <div class="pager">
                <el-pagination class="pager"
                layout="total, prev, pager, next, jumper"
                :page-size="pageSize"
                :total="total"
                :current-page.sync="currentPage"
                @current-change="handlePageChange" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button type="success" :disabled="submitDiabled" @click="submit" :loading="submitLoading">确 定</el-button>
        <el-button type="info" @click="handleClose">取 消</el-button>
      </span>
  </el-dialog>

</template>
<script>
import {
  querySeaTemplate, // 查询模板地址
  querySeaUploadUrl, // 查询上传地址
  getModelInfo // 查询新题卡信息
} from '@/model/item-model'
import { assignFileEngine } from '@/model/pj-server-model'
import common from '@/util/common'
import { queryCardList, selectCardForExam, queryCardForExam } from '@/model/card-model'
import {checkScanSoft} from '@/model/monitor-scan-model'
import md5 from 'md5'
import _ from 'lodash'

export default {
  data () {
    return {
      submitDiabled: false,
      submitLoading: false,
      existModel: false,
      blurJustNow: false,
      selectedCardId: '',
      menuIndex: '1',
      seaUploadUrl: '',
      cardTypes: [ {
        type: 'A3_2',
        name: 'A3双折页'
      }, {
        type: 'A3_3',
        name: 'A3三折页'
      }, {
        type: 'A4',
        name: 'A4纸'
      }],
      codeTypes: [
      //   {
      //   type: 'manualcode',
      //   name: '手写'
      // },
        {
          type: 'omr',
          name: 'OMR'
        }, {
          type: 'code',
          name: '条码'
        }],
      // 查询条件
      search_dateVals: '',
      search_cardType: '',
      search_cardName: '',
      search_codeType: '',
      total: 0,
      pageSize: 8,
      currentPage: 1,
      cardData: [],
      selectedCard: '',
      templetePath: '',
      cardInfo: { cut: [], omr: [], zg: [] }
    }
  },
  props: {
    examName: {
      type: String,
      required: true,
      default: ''
    },
    examId: {
      type: String,
      required: true,
      default: ''
    },
    subjectId: {
      type: String,
      required: true
    },
    subjectName: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    drawZgURL () {
      return `/collect-paper-block/${this.examId}/${decodeURI(this.examName)}/${this.subjectId}/${decodeURI(this.subjectName)}`
    },
    modelURL () {
      // let origin = window.location.origin || (window.location.protocol + '//' + window.location.host)
      let hytType = 'HYTHTTPSeaKW'
      if (this.libType === '0') {
        hytType = 'HYTHTTPSea'
      }
      let token = md5(this.subjectId + this.examId + 'seaskyland')
      // let token = ''
      return 'HYTHTTPAUTO://1022?|' + this.seaUploadUrl +
              '|examId=' + this.examId +
              '|subjectId=' + this.subjectId + '|token=' + token +
              '&esbUrl=' + origin + '/ESB/&scanUrl=' + hytType + '|modelinfo=' + this.templetePath
    },
    userInfo () {
      return common.getUserInfo()
    },
    paperType () {
      if (this.menuIndex === '2') {
        return '1'
      } else {
        return '2'
      }
    },
    newOmrStr () {
      return this.calcOmrStr(this.cardInfo.omr).join('，')
    }
  },

  methods: {
    drawZg () {
      window.open(this.drawZgURL)
    },
    // 收集题卡
    getPaperCard () {
      // 暂时关闭监测
      checkScanSoft().then((res) => {
        if (res.result.toString() === 'true') {
          if (res.data.install.toString() === 'true') {
            window.location.href = this.modelURL
          }
        }
      }).catch(() => {
        this.$message.error('请先安装或升级最新版本的答卷扫描工具!')
      })
      // window.location.href = this.modelURL
    },
    /**
     * 转化连续数字
     * @author wangk 2018-11-20T11:49:26+0800
     * @param  {Array[Number]}  nums 已排序的数字: [1, 2, 3, 4, 5, 16, 20, 21, 35, 36, 37, 38]
     * @param  {String} seperator 分隔符
     * @return {Array[String]}           ["1-5", "16", "20-21", "35-38"]
     */
    calcSerialNumsStr (nums = [], seperator = '-') {
      let numsStrs = []
      let length = nums.length
      if (length > 0) {
        let beginId = nums[0] // 1
        let endId = nums[0]
        nums.reduce((prev, curr, index) => {
          // console.log(prev, curr, index)
          if (curr === prev + 1) {
            endId = curr
            if (index + 1 === length) {
              numsStrs.push(beginId + seperator + endId)
            }
          } else {
            if (endId === beginId) {
              numsStrs.push(endId.toString())
            } else {
              numsStrs.push(beginId + seperator + endId)
            }
            beginId = curr
            endId = curr
          }
          return curr
        })
      }
      return numsStrs
    },
    // [ {Item_Value: "1", Item_Id: "1"}, {Item_Value: "2", Item_Id: "2"} ]
    /**
     * 生成 omr 题号字符串
     */
    calcOmrStr (omrs) {
      // 先取出所有的 Item_Id, 并全部转化为 number 类型
      let ids = []
      omrs.forEach(omr => {
        ids.push(parseInt(omr.Item_Id, 10))
      })
      ids.sort((a, b) => a - b) // [1, 2, 3, 4, 5, 16, 20, 21, 35, 36, 37, 38]
      return this.calcSerialNumsStr(ids)
    },
    getDates () {
      let beginDate = ''
      let endDate = ''
      try {
        beginDate = this.search_dateVals[0] || ''
        endDate = this.search_dateVals[1] || ''
      } catch (e) {}
      return { beginDate, endDate }
    },
    menuSelect (menuIndex, indexPath) {
      if (menuIndex !== this.menuIndex) {
        this.search_dateVals = ''
        this.search_cardType = ''
        this.search_cardName = ''
        this.search_codeType = ''
        this.cardData.splice(0, this.cardData.length)
      }
      this.menuIndex = menuIndex
      this.currentPage = 1
      this.searchCard(-1)
    },
    searchCard (currentPage = 1) {
      if (currentPage === -1) {
        this.currentPage = 1
      } else {
        this.currentPage = currentPage
      }
      let dates = this.getDates()
      let param = {
        data: {
          userId: this.userInfo.userId,
          beginTime: dates.beginDate,
          endTime: dates.endDate,
          cardName: this.search_cardName.trim(),
          cardType: this.search_cardType,
          paperType: this.paperType,
          zkzhType: this.search_codeType
        },
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      queryCardList(param).then((cardList) => {
        this.cardData.splice(0, this.cardData.length)
        this.total = cardList.total
        for (let card of cardList.data) {
          if (card.zkzhType === 'manualcode') {
            card.zkzhType = '手写'
          } else if (card.zkzhType === 'omr') {
            card.zkzhType = 'OMR'
          } else if (card.zkzhType === 'code') {
            card.zkzhType = '条码'
          }
          card.createTime = common.dateTimeFormat(card.createTime, 'yyyy-MM-dd')
          card.cardName = card.title
          if (card.title.length > 10) {
            card.cardName = card.title.substr(0, 9) + '...'
          }
          if (card.paperName.length > 10) {
            card.paperNameShort = card.paperName.substr(0, 7) + '...'
          }
          if (card.cardType === 'A4') {
            card.cardType = 'A4纸'
          } else if (card.cardType === 'A3_2') {
            card.cardType = 'A3双折页'
          } else if (card.cardType === 'A3_3') {
            card.cardType = 'A3三折页'
          }
          card.cardIdEmpty = ''
          this.cardData.push(card)
        }
        for (let card of this.cardData) {
          if (card.cardId === this.selectedCardId) {
            if (this.menuIndex === '2') {
              this.$refs.onlineCardTable.setCurrentRow(card)
            } else if (this.menuIndex === '3') {
              this.$refs.scoreCardTable.setCurrentRow(card)
            }
            this.selectedCardId = card.cardId
          }
        }
      })
    },
    queryCardIdForExam () {
      queryCardForExam({
        examid: this.examId,
        subjectid: this.subjectId,
        orgid: this.userInfo.origanization
      }).then((data) => {
        if (data.result.toString() === 'true') {
          if (data.data.paperType) {
            this.menuIndex = (parseInt(data.data.paperType) + 1).toString()
            this.selectedCardId = data.data.cardid
            this.searchCard(-1)
          }
        } else {
          this.$message.error('查询题卡信息失败!')
        }
      })
    },
    selectRow (currentRow, oldCurrentRow) {
      this.selectedCard = currentRow
      this.selectedCardId = this.searchCard.cardId
    },
    handlePageChange (pageNum) {
      this.currentPage = pageNum
      this.searchCard(this.currentPage)
    },
    // 检查客观题和主观题id是否重复
    checkItemUniq () {
      try {
        this.$msg.close()
      } catch (error) {}
      let isUniq = true
      this.cardInfo.omr.map(omr => {
        this.cardInfo.zg.map(cut =>{
          if (omr.Item_Id === cut.Item_Id) {
            isUniq = false
          }
        })
      })
      return isUniq
    },
    submit () {
      if (this.menuIndex === '1') {
        if (this.existModel === false) {
          this.$message('请点击 开始收集 进行操作.')
        } else {
          let checkItemUniq = this.checkItemUniq()
          if (checkItemUniq) {
            this.$emit('dialog-close', {examId: this.examId, operate: 'updateTaskMonitor'})
          } else {
            try {
              this.$msgbox.close()
            } catch (error) {}
            this.alertError("<span>主观题和客观题号不能重复,请修改客观题或主观题不重复题号后,<strong style='color: red'>重新收集</strong>客观题信息,否则将造成题目错漏!</span>")
          }
        }
      } else {
        this.submitLoading = true
        let param = {
          data: {
            examId: this.examId,
            subjectId: this.subjectId,
            cardId: this.selectedCardId,
            paperType: this.selectedCard.paperType
          }
        }
        selectCardForExam(param).then((result) => {
          if (result.result.toString() === 'true') {
            this.submitLoading = false
            this.$message('设置题卡信息成功！')
            setTimeout(() => {
              this.$emit('dialog-close', {examId: this.examId, operate: 'updateTaskMonitor'})
            }, 1000)
          } else {
            this.$message.error('已开始扫描，无法更新题卡信息！')
            this.submitLoading = false
          }
        })
      }
    },
    handleClose (done) {
      let checkItemUniq = this.checkItemUniq()
      if (!checkItemUniq) {
        try {
          this.$msgbox.close()
        } catch (error) {}
        this.alertError("<span>主观题和客观题号不能重复,请修改客观题或主观题不重复题号后,<strong style='color: red'>重新收集</strong>客观题信息,否则将造成题目错漏!</span>")
        return
      }
      // 不调用 done, 而应该让父组件去关闭弹窗
      this.$emit('dialog-close', {})
    },
    initData () {
      let param = {
        examId: this.examId,
        subjectId: this.subjectId
      }
      // this.checkCardInfo()
      let promise = assignFileEngine(param)
      Promise.all([promise, querySeaUploadUrl()]).then(([fileEngine, uploadUrl]) => {
        console.log(fileEngine, uploadUrl)
        if (fileEngine.result === 'true') {
          this.libType = fileEngine.libType
        } else {
          this.libType = '1'
        }
        try {
          this.seaUploadUrl = uploadUrl[0]
        } catch (e) {
          this.seaUploadUrl = ''
        }
      }).then(() => {
        this.getExistModelInfo()
      }).catch(e => {
        console.log(e)
        this.libType = '1'
        this.seaUploadUrl = ''
        this.$message.error('查询文件引擎或上传地址失败！')
      })
    },
    getExistModelInfo () {
      querySeaTemplate({
        examId: this.examId,
        subjects: [this.subjectId]
      }).then(res => {
        let param = {
          examId: this.examId,
          subjectId: this.subjectId
        }
        if (res.subject[0].templetePath) {
          this.existModel = true
          if (_.endsWith(res.subject[0].templetePath, 'zip')) {
            this.templetePath = res.subject[0].templetePath
          } else {
            this.templetePath = ''
          }
          // 有模板地址信息, 则查询新老题卡信息
          getModelInfo(param).then((cardRes) => {
            cardRes.zg.sort((a, b) => {
              return parseInt(a.Item_Id) - parseInt(b.Item_Id)
            })
            this.cardInfo = cardRes
            let checkItemUniq = this.checkItemUniq()
            if (!checkItemUniq) {
              try {
                this.$msgbox.close()
              } catch (error) {}
              this.alertError("<span>主观题和客观题号不能重复,请修改客观题或主观题不重复题号后,<strong style='color: red'>重新收集</strong>客观题信息,否则将造成题目错漏!</span>")
            }
          }).catch(ex => {
            this.$message.error('查询题卡信息失败')
          })
        }
      })
    },
    blurHandler () { this.blurJustNow = true },
    focusHandler () {
      if (this.blurJustNow && this.menuIndex === '1') {
        this.getExistModelInfo()
      }
    },
    addWindowListener () {
      window.removeEventListener('blur', this.blurHandler)
      window.removeEventListener('focus', this.focusHandler)
      window.addEventListener('blur', this.blurHandler, false)
      window.addEventListener('focus', this.focusHandler, false)
    },
    dialogOpen () {
      this.initData()
      this.queryCardIdForExam()
    },
    /**
     * 错误弹窗
     */
    alertError (errorMsg) {
      let content = `<div class='kw-alert__wrapper'>
        <div class='kw-alert__icon kw-alert__icon--warning'></div>
        ${errorMsg}
      </div>`
      this.$alert(content, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    },

    // 成功弹窗
    alertSuccess (msg) {
      const h = this.$createElement
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--success`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--success']
        }, msg)
      ])
      this.$alert(vnode, '', {
        confirmButtonText: '确定',
        center: true,
        showClose: false,
        showCancelButton: false,
        callback: action => {
          // common.goHome()
        }
      })
    }
  },
  mounted () {
    this.addWindowListener()
  },
  created () {
    this.initData()
    this.queryCardIdForExam()
  }
}
</script>
<style lang="scss" scoped>
.select-menu{
  height: 100%;
  background: transparent;
}
.main-container{
  display: flex;
  flex-direction: row;
}
.left-container{
  width: 120px;
}
.right-container{
  $width: 960px;
  $height: 600px;
  $button-height: 191px;
  $button-height-small:80px;
  $button-width: 210px;
  $button-width-small: 166px;
  $border-color: #D8D8C9;
  $right-width: 256px;
  $green: #6EA86E;
  width: 100%;
  padding-left:20px;
  .oprate-wrap{
    height: 480px;
    .filter-name {
      white-space: nowrap;
    }
  }
   // 没有题卡信息时
  .none-card-info {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    .paper-left{
      width: 650px;
      height: 480px;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      .item-info-wrap{
        display: flex;
        width: 95%;
        height: 100%;
        flex-direction: column;
        .title {
          padding-bottom: 10px;
          border-bottom: 1px solid $border-color;
          .key {
            font-weight: bold;
            font-size: 20px;
          }
        }
        .items{
          display: flex;
          width: 100%;
          height: 100%;
          overflow: auto;
          justify-content: center;
          .omr-info {
            margin-top: 10px;
            width: 250px;
          }
          .zg-info {
            margin-top: 10px;
            width: 250px;
            margin-left: 50px;
          }
          .omr-nos {
            margin: 0;
          }
        }
      }
    }
    .paper-right{
      width: 210px;
      height: 480px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      border-left: 1px solid $border-color;
    }
    .exam-name {
      margin: 0;
      position: absolute;
      font-size: 16px;
      top: ($height - $button-height) / 2 - 140px;

    }

    .collect-button {
      width: $button-width;
      height: $button-height;
      // line-height: $button-size;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: black;
      border-radius: 10px;
      box-shadow: -1px -1px 15px #888888;
      text-decoration: none;
      .iconfont {
        font-size: 60px;
        width: 60px;
        height: 60px;
        line-height: 60px;
      }

      .text {
        font-size: 16px;
      }
    }

    .collect-button-small{
      width: 166px;
      height: 52px;
      // line-height: $button-size;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: black;
      border-radius: 10px;
      box-shadow: 0px 0px 3px 1px #888888;
      text-decoration: none;
      flex-direction: row;
      background-color: #468f64;
      .iconfont {
        font-size: 30px;
        width: 40px;
        height: 45px;
        line-height: 52px;
        color: white;
      }

      .text {
        font-size: 16px;
      }
    }
  }
  .onlie-card{
    display: flex;
    flex-direction: column;
  }
  .search-container{
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid $border-color;
    height: 36px;
    .search-item{
      width:100px;margin-left:20px;
    }
  }
  .table_container{
    margin-top:10px;
    .card-table{
      height: 397px;
    }
    .pager{
      margin-top: 10px;
      float: right;
    }
  }
  .date-picker{
    width: 230px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exam/task/card-collection/CardCollectionForSchool.vue